import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import DashboardPanelCompany from '../../containers/DashboardPanelCompany';

const useStyles = makeStyles((theme) => ({
  actionBar: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  headerStyle: {
    textAlign: 'center',
    marginTop: 100
  }
}));

const OverviewDashboard = (props) => {
  const classes = useStyles();

  return (
    <React.Fragment>
      <div className={classes.actionBar}></div>
      <DashboardPanelCompany />
    </React.Fragment>
  );
};

export default OverviewDashboard;
